import axios from "axios";
import { ICompany, CompanyFormData } from "./company";
import env from "../variables/config";

axios.defaults.baseURL = env.apiUrl;

const config = () => ({
  headers: { Authorization: "Bearer " + localStorage.getItem("token") }
});

// Get all companies (admin only)
export const getCompanies = async (params?: {
  status?: string;
  industry?: string;
  size?: string;
  fundingStage?: string;
  search?: string;
  tags?: string[];
  sortBy?: string;
  order?: string;
  page?: number;
  limit?: number;
}) => {
  const searchParams = new URLSearchParams();
  
  if (params?.status) searchParams.append("status", params.status);
  if (params?.industry) searchParams.append("industry", params.industry);
  if (params?.size) searchParams.append("size", params.size);
  if (params?.fundingStage) searchParams.append("fundingStage", params.fundingStage);
  if (params?.search) searchParams.append("search", params.search);
  if (params?.tags) params.tags.forEach(tag => searchParams.append("tags", tag));
  if (params?.sortBy) searchParams.append("sortBy", params.sortBy);
  if (params?.order) searchParams.append("order", params.order);
  if (params?.page) searchParams.append("page", String(params.page));
  if (params?.limit) searchParams.append("limit", String(params.limit));
  
  const url = `/admin/companies${searchParams.toString() ? `?${searchParams.toString()}` : ""}`;
  const res = await axios.get(url, config());
  return res.data;
};

// Get a specific company (admin only)
export const getCompany = async (id: string): Promise<ICompany> => {
  const res = await axios.get(`/admin/companies/${id}`, config());
  return res.data;
};

// Create a new company (admin only)
export const createCompany = async (company: CompanyFormData): Promise<ICompany> => {
  const res = await axios.post("/admin/companies", company, config());
  return res.data;
};

// Update a company (admin only)
export const updateCompany = async (id: string, company: Partial<CompanyFormData>): Promise<ICompany> => {
  const res = await axios.put(`/admin/companies/${id}`, company, config());
  return res.data;
};

// Delete a company (admin only)
export const deleteCompany = async (id: string) => {
  const res = await axios.delete(`/admin/companies/${id}`, config());
  return res.data;
};

// Batch create companies (admin only)
export const batchCreateCompanies = async (companies: CompanyFormData[]) => {
  const res = await axios.post("/admin/companies/batch", { companies }, config());
  return res.data;
};

// Get company by SIREN (admin only)
export const getCompanyBySiren = async (siren: string): Promise<ICompany> => {
  const res = await axios.get(`/admin/companies/siren/${siren}`, config());
  return res.data;
};

// Get company stats (admin only)
export const getCompanyStats = async () => {
  const res = await axios.get("/admin/companies/stats/admin", config());
  return res.data;
};

// Get distinct filter values (admin only)
export const getCompanyFilterValues = async (field: string) => {
  const res = await axios.get(`/admin/companies/filters/values?field=${field}`, config());
  return res.data;
};

// Create company and signals from event
export const createCompanyAndSignalsFromEvent = async (eventId: string) => {
  const res = await axios.post(`/admin/events/${eventId}/create-company-signals`, {}, config());
  return res.data;
};